import React, { useEffect, useState } from "react";
import {
  Card,
  Typography,
  Flex,
  Row,
  Col,
  Empty,
  Space,
  Divider,
  Select,
  Input,
  Upload,
  Button,
  Table,
  Tag,
  Form,
  message,
} from "antd";
import { CloudDownloadOutlined, UploadOutlined } from "@ant-design/icons";
import axiosInstance from "../../services/axiosInstance";
import { catchError } from "../../utils/errorHandler";

const { Title, Text, Paragraph } = Typography;

const TicketActionModal = ({
  ticket,
  onClose,
  fetchAllTicketListData,
  filters,
}) => {
  const [form] = Form.useForm();
  const [uploadFile, setUploadFile] = useState([]);
  const [formSubmitLoading, setFormSubmitLoading] = useState(false);

  const fileList = ticket?.issue_files || [];

  const getFileIcon = (fileName) => {
    const ext = fileName?.split(".").pop().toLowerCase();
    const icons = {
      pdf: "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/PDF_file_icon.svg.png",
      doc: "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/docx_icon.svg.png",
      docx: "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/docx_icon.svg.png",
      jpg: "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/jpeg-jpg.png",
      jpeg: "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/jpeg-jpg.png",
      png: "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/png1.webp",
      zip: "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/zipppp.png",
      ppt: "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/images_1.png",
      pptx: "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/images_1.png",
    };
    return (
      icons[ext] ||
      "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/file-file-type.svg"
    );
  };

  // const ticketData = [
  //     {
  //         key: '1',
  //         category: ticket?.category || 'N/A',
  //         referenceTicket: ticket?.reference_ticket || 'N/A',
  //     },
  // ];

  // const columns = [
  //     {
  //         title: 'Category',
  //         dataIndex: 'category',
  //         key: 'category',
  //     },
  //     {
  //         title: 'Reference Ticket',
  //         dataIndex: 'referenceTicket',
  //         key: 'referenceTicket',
  //     },
  // ]

  const handleUploadChange = (info) => {
    if (info.fileList.length > 0) {
      setUploadFile(info.fileList || []);
    } else {
      setUploadFile([]);
    }
  };

  const onFinish = async () => {
    setFormSubmitLoading(true);
    try {
      const values = await form.validateFields();

      const formData = new FormData();
      formData.append("assigned_to", values.assignee);
      if (values.remarks) {
        formData.append("action_details", values.remarks);
      }
      formData.append("status", values.status.toUpperCase());

      if (uploadFile.length > 0) {
        uploadFile.forEach((file) => {
          formData.append("attachment_files", file.originFileObj);
        });
      }

      const res = await axiosInstance.post(
        `/useraccount/v2/ticket/action/${ticket?.uid}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.status === 200) {
        message.success(res.data.message);
        form.resetFields();
        setUploadFile([]);
        fetchAllTicketListData(filters);
        onClose();
        setFormSubmitLoading(false);
      }
    } catch (error) {
      await catchError(error);
      setFormSubmitLoading(false);
    }
  };

  useEffect(() => {
    if (ticket) {
      form.setFieldsValue({
        assignee: ticket?.assigned_to || undefined,
        status: ticket?.status || undefined,
        remarks: ticket?.action_details || undefined,
      });
    }
  }, [ticket, form]);

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Flex justify="space-between" align="center">
        <Title level={5} style={{ margin: 0 }}>
          {ticket?.subject || "Ticket Title"}
        </Title>
        <Tag
          color={
            ticket?.status === "Open"
              ? "red"
              : ticket?.status === "Closed"
              ? "green"
              : ticket?.status === "In Progress"
              ? "yellow"
              : "gray"
          }>
          {ticket?.status || "Pending"}
        </Tag>
      </Flex>

      <Paragraph style={{ margin: "0px", marginTop: "-10px" }}>
        {ticket?.description || "No description provided."}
      </Paragraph>

      {fileList && fileList?.length > 0 && (
        <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>
          {fileList?.map((item, index) => (
            <Col xs={24} sm={8} key={index}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #D3D3D3",
                  padding: "10px",
                  borderRadius: "10px",
                }}>
                <div
                  style={{
                    height: "40px",
                    width: "40px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                  <img
                    style={{ height: "50px", width: "50px" }}
                    src={getFileIcon(item?.file_name)}
                    alt="file-icon"
                  />
                </div>
                <div style={{ flex: 1, marginLeft: "10px" }}>
                  <div
                    className="field-label"
                    style={{ fontWeight: "normal", wordBreak: "break-all" }}>
                    {item?.file_name
                      ? item?.file_name.length <= 13
                        ? item?.file_name
                        : `${item?.file_name.slice(0, 13)}.${item?.file_name
                            .split(".")
                            .pop()}`
                      : "No file name"}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      gap: "20px",
                      marginTop: "5px",
                      color: "gray",
                    }}>
                    <div>{(item?.file_size / 100).toFixed(2)} KB</div>
                    <div>
                      <a
                        href={item?.file_url}
                        target="_blank"
                        rel="noopener noreferrer">
                        <CloudDownloadOutlined
                          style={{ fontSize: "19px", color: "gray" }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      )}

      {/* <Table
                columns={columns}
                dataSource={ticketData}
                pagination={false}
                bordered
            /> */}

      <Divider orientation="center">Take Action</Divider>

      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="assignee"
              label="Assign To"
              rules={[
                { required: true, message: "Please select an assignee" },
              ]}>
              <Select
                placeholder="Select Assignee"
                options={[
                  // { label: 'Ankit Sharma', value: 'ankit' },
                  { label: "Sohil Khan", value: "sohil" },
                  { label: "Vidhi Tomar", value: "vidhi" },
                  { label: "Abhishek Sharma", value: "abhishek" },
                  { label: "Vineet Saraswat", value: "vineet" },
                ]}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              name="status"
              label="Status"
              rules={[{ required: true, message: "Please select a status" }]}>
              <Select
                placeholder="Select Status"
                options={[
                  { label: "Open", value: "OPEN" },
                  { label: "In Progress", value: "IN_PROGRESS" },
                  { label: "Closed", value: "CLOSED" },
                ]}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name="remarks" label="Remarks">
              <Input.TextArea rows={4} placeholder="Add your remarks here" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name="attachment"
              label="Attachment"
              valuePropName="fileList"
              getValueFromEvent={(e) => e && e.fileList}>
              <Upload.Dragger
                name="files"
                multiple={true}
                maxCount={10}
                beforeUpload={() => false} // prevent auto upload
                onChange={handleUploadChange}>
                <p className="ant-upload-drag-icon">
                  <UploadOutlined style={{ fontSize: 30, color: "#1677ff" }} />
                </p>
                <p className="ant-upload-text">
                  Click or drag files to this area to upload
                </p>
              </Upload.Dragger>
            </Form.Item>
          </Col>
        </Row>

        <Flex justify="end" style={{ marginTop: "20px" }}>
          <Button type="primary" onClick={onFinish} loading={formSubmitLoading}>
            Submit
          </Button>
        </Flex>
      </Form>
    </Space>
  );
};

export default TicketActionModal;
